//----------------------horrizontally zoom adjustable last one server--------------------

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tree } from "react-d3-tree";
import Sidebar from "./Sidebar";
import * as Icon from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import "./structure.css"; // Import your CSS file

const Structure = () => {
  const [treeData, setTreeData] = useState(null);
  const [toggleValue, setToggleValue] = useState(false);
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(0.8); // Initial zoom level (adjust for a zoomed-out view)
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, data: null });
  const { username, side } = useParams();

  useEffect(() => {
    getParentData();
  }, [username, side]);

  useEffect(() => {
    if (treeData) {
      const timeoutId = setTimeout(() => centerTree(zoom), 100); // Delay to ensure DOM is updated
      const handleResize = () => centerTree(zoom);

      window.addEventListener("resize", handleResize); // Add resize listener
      return () => {
        clearTimeout(timeoutId); // Clear timeout
        window.removeEventListener("resize", handleResize); // Remove listener
      };
    }
  }, [treeData, zoom]);

  const authtoken = localStorage.getItem("token");
  const token = `Bearer ${authtoken}`;

  const getParentData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/tree`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      const fetchedData = response.data;

      // If username and side are provided, filter to show specific branch
      let processedData = fetchedData;
      if (username && side) {
        processedData = findUserInTree(fetchedData, username, side);
      }

      const tree = transformDataToTree(processedData);
      setTreeData(tree);
    } catch (error) {
      console.error("Error: " + error);
    }
  };

  const findUserInTree = (node, targetUser, targetSide) => {
    if (!node) return null;

    if (node.name === targetUser) {
      // Return the specific side of this user
      if (targetSide === 'left' && node.left_child) {
        return node.left_child;
      } else if (targetSide === 'right' && node.right_child) {
        return node.right_child;
      }
      return null;
    }

    // Search in children
    const leftResult = findUserInTree(node.left_child, targetUser, targetSide);
    if (leftResult) return leftResult;

    const rightResult = findUserInTree(node.right_child, targetUser, targetSide);
    if (rightResult) return rightResult;

    return null;
  };

  const transformDataToTree = (data) => {
    const children = [];
    if (data.left_child) {
      children.push(transformDataToTree(data.left_child));
    }
    if (data.right_child) {
      children.push(transformDataToTree(data.right_child));
    }
    return {
      name: data.name,
      refCode: data.referral_code || "N/A",
      profilePhoto:
        data.profilePhoto ||
        "https://pronedvizhimost.ru/static/custom/img/default/user.png",
      children: children.length > 0 ? children : null,
      collapsed: false,
    };
  };

  const handleMouseEnter = (event, nodeDatum) => {
    const rect = event.target.getBoundingClientRect();
    const containerRect = document.querySelector('.tree-container').getBoundingClientRect();

    setTooltip({
      visible: true,
      x: rect.left - containerRect.left + rect.width / 2,
      y: rect.top - containerRect.top - 10,
      data: nodeDatum
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ visible: false, x: 0, y: 0, data: null });
  };

  const renderNode = ({ nodeDatum, toggleNode }) => {
    return (
      <foreignObject
        width="100"
        height="100"
        x="-50"
        y="-50"
        onClick={toggleNode}
      >
        <div style={{ textAlign: "center", cursor: "pointer" }}>
          <img
            src={`${process.env.REACT_APP_API_URL +
              process.env.REACT_APP_profile_IMAGE_URL +
              nodeDatum.profilePhoto
              }`}
            alt={nodeDatum.name}
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
            onMouseEnter={(e) => handleMouseEnter(e, nodeDatum)}
            onMouseLeave={handleMouseLeave}
            onError={(e) => {
              e.target.src =
                "https://pronedvizhimost.ru/static/custom/img/default/user.png";
            }}
          />
          <div style={{ marginTop: "5px", backgroundColor: "#fefeec" }}>
            {nodeDatum.name}
          </div>
        </div>
      </foreignObject>
    );
  };

  const centerTree = (zoomLevel) => {
    const dimensions = document
      .querySelector(".tree-container")
      .getBoundingClientRect();
    const newTranslate = {
      x: dimensions.width / 2, // Center horizontally
      y: dimensions.height / 4, // Center vertically with padding
    };
    setTranslate(newTranslate);
    setZoom(zoomLevel); // Set initial zoom
  };

  return (
    <div
      className="container-fluid"
    >
      <div className="row">
        {/* Sidebar container */}
        <div className="col-lg-2 p-0">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>

        {/* Main content area */}
        <div
          className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper"
          style={{ padding: 0, margin: 0 }}
        >
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          ></Icon.ArrowRight>
          {username && side && (
            <div className="text-center mb-3">
              <h4>Tree View: {username} - {side.charAt(0).toUpperCase() + side.slice(1)} Branch</h4>
            </div>
          )}
          <div
            className="row dashboard-content structure-content"
            style={{ margin: 0, padding: 0 }}
          >
            <div
              className="tree-container"
              style={{
                textAlign: "center",
                position: "relative",
                padding: 0,
                margin: 0,
                height: "100vh",
                overflow: "auto",
              }}
            >
              {treeData ? (
                <Tree
                  data={treeData}
                  renderCustomNodeElement={renderNode}
                  orientation="vertical"
                  collapsible
                  pathFunc="step"
                  separation={{ siblings: 2, nonSiblings: 2 }}
                  translate={translate} // Center the tree initially
                  zoom={zoom} // Set initial zoom level
                  scaleExtent={{ min: 0.5, max: 2 }} // Control zoom scale
                />
              ) : (
                <p>Loading...</p>
              )}

              {/* Custom Tooltip */}
              {tooltip.visible && tooltip.data && (
                <div
                  className="custom-bubble-tooltip"
                  style={{
                    position: 'absolute',
                    left: tooltip.x,
                    top: tooltip.y,
                    transform: 'translateX(-50%) translateY(-100%)',
                    zIndex: 1000,
                    pointerEvents: 'none'
                  }}
                >
                  <div className="tooltip-content">
                    <div className="tooltip-header">
                      <strong>{tooltip.data.name}</strong>
                    </div>
                    <div className="tooltip-body">
                      <div className="tooltip-item">
                        <span className="tooltip-label">Ref Code: {tooltip.data.refCode}</span>
                      </div>
                      {tooltip.data.children && tooltip.data.children.length > 0 && (
                        <div className="tooltip-item">
                          <span className="tooltip-label">------------</span>
                          <div className="tooltip-children">
                            {tooltip.data.children.map((child, index) => (
                              <div key={index} className="child-item">
                                • {child.name} ({child.refCode})
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {(!tooltip.data.children || tooltip.data.children.length === 0) && (
                        <div className="tooltip-item">
                          <span className="tooltip-label">------------</span>
                          <span className="tooltip-value">None</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="tooltip-arrow"></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Structure;
